import { createFileRoute } from "@tanstack/react-router";
import ServiceAreas from "@/pages/ServiceAreas";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/service-areas/")({
  head: () =>
    seo({
      title: "Minnesota Service Areas | Cedar Creek Construction",
      description:
        "Roofing and siding services across the Minneapolis north metro: Anoka, Andover, Blaine, Coon Rapids, Ham Lake, Brooklyn Park, Cambridge, and more.",
      path: "/service-areas",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Service Areas", path: "/service-areas" },
      ]),
    }),
  component: ServiceAreas,
});
